
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.659 14.837l-1.876-1.961 6.225-5.457 1.109 1.193-5.458 6.225zm8.1 5.543C20.722 18.42 22 15.69 22 12.62c0-6.054-4.945-11-11-11s-11 4.946-11 11c0 3.07 1.194 5.799 3.24 7.76l1.535-1.535c-1.62-1.62-2.558-3.752-2.558-6.224A8.77 8.77 0 0111 3.836a8.77 8.77 0 018.783 8.783c0 2.388-1.023 4.605-2.558 6.225l1.535 1.536z","fill":"#E5B22D"}})])
          )
        }
      }
    